import React, { useState, useEffect } from 'react';
import { Layout, Menu, Avatar, Dropdown, Space } from 'antd';
import { UserOutlined, LogoutOutlined } from '@ant-design/icons';
import { Link, useNavigate } from 'react-router-dom';
import slugs from '../../resources/slugs';
import {
  AppLayoutWrapper,
  GlassSider,
  MainContent,
  LogoContainer,
  StyledMenu
} from "./style";

const { Header } = Layout;

const LoanDashboardLayout = ({ children }) => {
  const [adminName, setAdminName] = useState(localStorage.getItem('loanAdminUser')); // Default name
  const navigate = useNavigate();
  const [roles, setRoles] = useState([]);

  useEffect(() => {
    const rawRoles = localStorage.getItem('roles');
    try {
      const parsed = JSON.parse(rawRoles || '[]');
      setRoles(Array.isArray(parsed) ? parsed : [parsed]);
    } catch {
      setRoles(rawRoles ? [rawRoles] : []);
    }
  }, []);

  useEffect(() => {
    // Try to get admin name/email from localStorage
    const email = localStorage.getItem('adminEmail');
    if (email) {
      setAdminName(email.split('@')[0]); // Use part before @ as name
    } else {
      // If no email, check for loanAdminToken and redirect to login if not found
      const token = localStorage.getItem('loanAdminToken');
      if (!token) {
        navigate('/loan-admin-login'); // Redirect to a generic loan login if no token
      }
    }
  }, [navigate]);

  const handleLogout = () => {
    localStorage.clear(); // Clear all session data for a clean logout
    window.location.href = slugs.loan_admin_login; // Hard redirect to bypass React transition blips
  };

  const menu = (
    <Menu selectable={false} style={{
      background: 'rgba(255, 255, 255, 0.9)',
      backdropFilter: 'blur(20px)',
      border: '1px solid rgba(0, 0, 0, 0.05)',
      borderRadius: '16px',
      padding: '8px'
    }}>
      <Menu.Item key="logout" onClick={handleLogout} style={{ borderRadius: '12px' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '10px', color: 'var(--waya-red)' }}>
          <LogoutOutlined />
          <span>Logout</span>
        </div>
      </Menu.Item>
    </Menu>
  );

  return (
    <AppLayoutWrapper>
      <GlassSider
        collapsible
        width={280}
      >
        <LogoContainer>
          <h2 style={{ color: 'var(--waya-red)', margin: 0, fontSize: 24, fontWeight: 800, letterSpacing: '1px' }}>WAYA</h2>
        </LogoContainer>
        <StyledMenu>
          <Menu
            theme='light'
            defaultSelectedKeys={['1']}
            mode="inline"
            items={[
              {
                key: 'loan_analytics_dashboard',
                label: <Link to={slugs.loan_analytics_dashboard}>Dashboard</Link>,
              },
              {
                key: 'loan_pending_loans',
                label: <Link to={slugs.loan_pending_loans}>Pending Loans</Link>,
              },
              {
                key: 'all_loans',
                label: <Link to={slugs.all_loan_requests}>All Loans</Link>,
              },
              (roles?.includes('OWNER') || roles?.includes('SUPER_ADMIN')) && {
                key: 'loan_audit_logs',
                label: <Link to={slugs.loan_audit_logs}>Audit Logs</Link>,
              },
              (roles?.includes('loan_disbursement')) && {
                key: 'finance_approver_disbursement',
                label: <Link to={slugs.finance_approver_disbursement}>Disbursements</Link>,
              }
            ].filter(Boolean)}
          />
        </StyledMenu>
      </GlassSider>

      <AppLayoutWrapper className="site-layout">
        <Header
          className="site-layout-background"
          style={{
            background: '#fff',
            display: 'flex',
            justifyContent: 'end',
            alignItems: 'center',
          }}
        >
          <Dropdown overlay={menu} trigger={['click']}>
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                cursor: 'pointer',
              }}
            >
              <Avatar shape='circle' size='large' icon={<UserOutlined />} />
              <div style={{ marginLeft: '10px' }}>
                {(() => {
                  try {
                    const parsed = JSON.parse(adminName);
                    return (parsed?.firstName || '') + ' ' + (parsed?.lastName || '');
                  } catch {
                    return adminName || 'Admin';
                  }
                })()}
              </div>
            </div>
          </Dropdown>
        </Header>
        <MainContent>
          <div className="content-inner">
            {children}
          </div>
        </MainContent>
      </AppLayoutWrapper>
    </AppLayoutWrapper>
  );
};

export default LoanDashboardLayout;